import apiClient from '../apiClient';
import { GET_TRANSPORTATION_BY_FROM_TO_DATE_URL } from '../apiUrl';

const getTransportationByFromToDateApi = (from, to, date) => {
  return apiClient.get(GET_TRANSPORTATION_BY_FROM_TO_DATE_URL(from, to, date));
};

export default getTransportationByFromToDateApi;
